import { render, staticRenderFns } from "./CommunicationTest.vue?vue&type=template&id=a83e261c&"
import script from "./CommunicationTest.vue?vue&type=script&lang=js&"
export * from "./CommunicationTest.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports